<p i18n>All references will be renewed</p>

<sc-file-upload #fileUpload
                [uploadUrl]="config.reUploadUrl$ | async"
                [validationRules]="config.validationRules$ | async"
                (uploadStarted)="onUploadStarted()"
                (uploadCompleted)="onUploadCompleted()">
</sc-file-upload>

<p-button label="Reupload"
          i18n-label
          class="flex justify-content-center mt-3"
          [loading]="requestInProcess"
          [disabled]="!fileUpload.isValid()"
          (onClick)="fileUpload.startUpload()">
</p-button>